<div>
  <label (click)="openList()" [hidden]="!label || label.length == 0">{{
    label
  }}</label>

  <section outsideClick (outsideClick)="onClickOutside($event)">
    <ul [hidden]="!listOpen" [ngClass]="{ 'dropdown-list': listDown }">
      <li
        *ngFor="let option of options; let optionIndex = index"
        (click)="selectOption(option, optionIndex)"
        [ngClass]="{ selected: option.selected }"
      >
        <i [ngClass]="{ multiple: multiple }">
          <svg viewBox="0 0 21.02 14.02">
            <path
              fill-rule="evenodd"
              d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
            />
          </svg>
        </i>
        <span>{{ option[key] }}</span>
      </li>
    </ul>
    <span (click)="openList()">
      <i
        [ngClass]="{ 'text-ellipsis': textEllipsis > 0 }"
        [ngStyle]="textEllipsis > 0 && { width: textEllipsis + 'px' }"
        >{{ value.label }}</i
      >
      <svg width="10px" height="7px">
        <path
          fill-rule="evenodd"
          fill="rgb(135, 155, 175)"
          d="M1.047,0.499 L-0.003,1.547 L4.999,6.539 L10.001,1.547 L8.950,0.499 L4.999,4.442 L1.047,0.499 Z"
        />
      </svg>
    </span>
  </section>

  <input type="hidden" [ngModel]="value" placeholder="{{ placeholder }}" />
</div>
